import { render, staticRenderFns } from "./LeaveWorkflow.vue?vue&type=template&id=788f92e6"
import script from "./LeaveWorkflow.vue?vue&type=script&lang=js"
export * from "./LeaveWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports